module.exports = "https://cdn.hellotech.com/client-assets/tech-client-speaker-mobile_51ac60074a50f13ef0e8fc1cdc35cc28.jpg";